// eslint-disable-next-line import/no-cycle
import {
  ComponentNameEnum, ConfigurationPanelStructureItemEnum, ElementPartTypeEnum, FieldsGroup, Property, StepperSignEnum,
  TemplateStructureEnum, TabItem,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import getBorderRadiusFieldConfig from '@/components/template-builder/config/fields/border-radius-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import {
  setAttribute, setCssButtonWidthProperty,
  setCssButtonDisplayProperty,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setMediaDisplay,
  toggleClass,
  setButtonAlignment,
  setButtonBorderRadius,
  cleanupButtonVml,
  refreshButtonVml,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName,
  getClassByName,
  getCssPropertyByName,
  hasClass,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import getButtonWidthFieldConfig from '@/components/template-builder/config/fields/button-width-config';
// eslint-disable-next-line import/no-cycle
import fontFieldConfig from '@/components/template-builder/config/fields/font-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';

// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
import getTextAlignNoJustifyFieldConfig from "@/components/template-builder/config/fields/text-align-no-justify-config";
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const widgetButtonFieldsConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.GROUP,
  label: 'templateBuilder.configs.widgetStyles',
  canSave: true,
  elementPartType: ElementPartTypeEnum.STYLES,
  tabPanel: {
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetBlockStyles',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.buttonBackgroundColor',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [{
              name: 'background-color',
              getter: getCssPropertyByName,
              setters: [
                setCssProperty,
                (selector: string) => {
                  // Refresh VML fillcolor if border-radius is active
                  refreshButtonVml(selector);
                },
              ],
            }],
            ...getColorFieldConfig('#ECECEC'),
          },
          {
            label: 'templateBuilder.fields.font',
            selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th, '
              + '{SELECTOR} table.spm_button:hover th a, {SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:hover, '
              + '{SELECTOR} table.spm_button th a:active',
            properties: [
              {
                name: 'font-family',
                getter: getCssPropertyByName,
                setters: [setCssProperty, (selector: string) => refreshButtonVml(selector)],
              },
              {
                name: 'font-size',
                getter: getCssPropertyByName,
                setters: [setCssProperty, (selector: string) => refreshButtonVml(selector)],
              },
              {
                name: 'font-weight',
                getter: getCssPropertyByName,
                setters: [setCssProperty, (selector: string) => refreshButtonVml(selector)],
              },
              {
                name: 'font-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'text-decoration-line',
                getter: getCssPropertyByName,
                setters: [setCssProperty, (selector: string) => refreshButtonVml(selector)],
              },
              {
                name: 'text-transform',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'color',
                getter: getCssPropertyByName,
                setters: [setCssProperty, (selector: string) => refreshButtonVml(selector)],
              },
            ],
            ...fontFieldConfig,
          },
          {
            label: 'templateBuilder.fields.textAlign',
            selector: '{SELECTOR} table.spm_button th a',
            properties: [{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] }],
            ...getTextAlignNoJustifyFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.spaceBetweenChars',
            selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th, '
              + '{SELECTOR} table.spm_button:hover th a, {SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:hover, '
              + '{SELECTOR} table.spm_button th a:active',
            properties: [{
              name: 'letter-spacing',
              getter: getCssPropertyByName,
              setters: [setCssProperty],
            }],
            ...getStepperFieldConfig(StepperSignEnum.PX),
          },
          {
            label: 'templateBuilder.fields.buttonWidth',
            selector: '{SELECTOR} table.spm_button th a',
            properties: [{
              name: 'display',
              getter: getCssPropertyByName,
              setters: [
                (selector: string, property: Property, widgetId: string) => {
                  // Get the button table element (class goes on table.spm_button, not on <a>)
                  const anchorEl = getTemplateIframeDocument()?.querySelector(selector);
                  const buttonTable = anchorEl?.closest('table.spm_button');
                  if (buttonTable) {
                    // inline-block = text width, block = full width
                    if (property.value === 'inline-block') {
                      buttonTable.classList.remove('spm_display_fullwidth_mobile');
                    } else {
                      buttonTable.classList.add('spm_display_fullwidth_mobile');
                    }
                  }
                  setCssButtonDisplayProperty(selector, property);
                  refreshButtonVml(selector);
                },
              ],
            }],
            fieldId: 'buttonWidth',
            onToggleOff: (selector: string) => {
              refreshButtonVml(selector);
            },
            onToggleOn: (selector: string) => {
              refreshButtonVml(selector);
            },
            ...getButtonWidthFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.displayFullWidthMobile',
            selector: '{SELECTOR} table.spm_button',
            properties: [{ name: 'spm_display_fullwidth_mobile', getter: hasClass, setters: [toggleClass] }],
            displayToggle: false,
            parentFieldId: 'buttonWidth',
            isVisible: (items: any[], parentFieldId: string) => {
              const property = items.find((item) => item.fieldId === parentFieldId);
              // Show only when button is text-adapted (inline-block), not full width (block)
              if (property && Array.isArray(property.properties) && property.properties.length && property.properties[0].value === 'inline-block') {
                return true;
              }
              return false;
            },
            disableHandler: () => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true',
            disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
            ...getDisplayFieldConfig('spm_display_fullwidth_mobile', ''),
          },
          {
            label: 'templateBuilder.fields.buttonAlignment',
            selector: '{SELECTOR} table.spm_button th',
            properties:[{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] }],
            ...getTextAlignNoJustifyFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.contours',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [{
              name: 'border-radius',
              getter: getCssPropertyByName,
              setters: [setButtonBorderRadius],
            }],
            onToggleOff: (selector: string) => {
              cleanupButtonVml(selector);
            },
            onToggleOn: (selector: string) => {
              refreshButtonVml(selector);
            },
            ...getBorderRadiusFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.borders',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [
              {
                name: 'border-color',
                getter: getCssPropertyByName,
                setters: [setCssProperty, (selector: string) => refreshButtonVml(selector)],
              },
              {
                name: 'border-style',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-width',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero, (selector: string) => refreshButtonVml(selector)],
              },
              {
                name: 'border-top-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-top-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-top-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-bottom-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-bottom-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-bottom-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-left-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-left-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-left-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-right-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-right-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-right-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...bordersFieldConfig,
          },
          {
            label: 'templateBuilder.fields.internalMargins',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [
                  setCssPropertyAndRemoveIfZero,
                  (selector: string) => refreshButtonVml(selector),
                ],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [
                  setCssPropertyAndRemoveIfZero,
                  (selector: string) => refreshButtonVml(selector),
                ],
              },
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [
                  setCssPropertyAndRemoveIfZero,
                  (selector: string) => refreshButtonVml(selector),
                ],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [
                  setCssPropertyAndRemoveIfZero,
                  (selector: string) => refreshButtonVml(selector),
                ],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
            onToggleOff: (selector: string) => {
              refreshButtonVml(selector);
            },
            onToggleOn: (selector: string) => {
              refreshButtonVml(selector);
            },
          },
        ],
      },
      getWidgetCommonStylesGroup('{SELECTOR} > tbody > tr > th'),
    ],
  },
};

export default widgetButtonFieldsConfig;
